import * as ImagePicker from "expo-image-picker";
import * as Location from "expo-location";
import * as Notifications from "expo-notifications";

import {
  type DiagnosticItem,
  DiagnosticStatus,
} from "@/schemas/app/diagnostic";

const fetchPermissionInfo = async (): Promise<DiagnosticItem[]> => {
  const locationPermission = await Location.getForegroundPermissionsAsync();
  const notificationPermission = await Notifications.getPermissionsAsync();
  const cameraPermission = await ImagePicker.getCameraPermissionsAsync();
  const mediaLibraryPermission =
    await ImagePicker.getMediaLibraryPermissionsAsync();

  return [
    {
      id: "locationPermission",
      name: "Location Permission",
      value: locationPermission.status,
      status:
        locationPermission.status === "granted"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.ERROR,
    },
    {
      id: "notificationPermission",
      name: "Notification Permission",
      value: notificationPermission.status,
      status:
        notificationPermission.status === "granted"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.ERROR,
    },
    {
      id: "cameraPermission",
      name: "Camera Permission",
      value: cameraPermission.status,
      status:
        cameraPermission.status === "granted"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.ERROR,
    },
    {
      id: "mediaLibraryPermission",
      name: "Media Library Permission",
      value: mediaLibraryPermission.status,
      status:
        mediaLibraryPermission.status === "granted"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.ERROR,
    },
  ];
};

export default fetchPermissionInfo;
